import { DatePipe } from '@angular/common';
import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LucideEye } from '@lucide/angular';
import { HistoryEntry } from '../history-entry.model';
import { HistoryText } from '../history-text/history-text';

/** Une entrée du fil d'historique : sa date, son origine, son résumé, et son détail dépliable. */
@Component({
  selector: 'app-history-entry-view',
  imports: [DatePipe, MatButtonModule, MatIconModule, MatTooltipModule, LucideEye, HistoryText],
  templateUrl: './history-entry-view.html',
  styleUrl: './history-entry-view.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { '[class.upcoming]': 'entry().upcoming' },
})
export class HistoryEntryView {
  readonly entry = input.required<HistoryEntry>();
  readonly expanded = signal(false);

  toggle(): void {
    this.expanded.update((expanded) => !expanded);
  }
}
